import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-sm-12 col-md-3" }
const _hoisted_4 = { class: "col-sm-12 col-md-9 content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "Ищем подходящие туры"),
  /*#__PURE__*/_createElementVNode("h4", { style: {"text-align":"center"} }, "Это не займет много времени")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = {
  class: "col-sm-12 col-md-3",
  style: {"z-index":"3"}
}
const _hoisted_8 = { class: "row gy-2" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "pretty_button hover_ignore" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "text-start" }, "Сортировка", -1)
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0 10px"} }, "Цена", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", { d: "M553.6,894.4c-29.4,51-77.6,51-107.1,0L22.6,160.1c-29.4-51-5.4-92.7,53.5-92.7h847.8c58.9,0,83,41.7,53.5,92.7L553.6,894.4L553.6,894.4z" })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0 10px"} }, "Рейтинг", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", { d: "M553.6,894.4c-29.4,51-77.6,51-107.1,0L22.6,160.1c-29.4-51-5.4-92.7,53.5-92.7h847.8c58.9,0,83,41.7,53.5,92.7L553.6,894.4L553.6,894.4z" })
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "pretty_button hover_ignore" }
const _hoisted_21 = { class: "p-0 m-0 mb-3 text-start" }
const _hoisted_22 = { class: "m-2" }
const _hoisted_23 = { class: "w-100 text-start" }
const _hoisted_24 = {
  key: 0,
  style: {"margin-left":"4px"}
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "m-0 text-start" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "pretty_button hover_ignore" }
const _hoisted_29 = { class: "p-0 m-0 mb-3 text-start" }
const _hoisted_30 = { class: "m-2 position-relative" }
const _hoisted_31 = { style: {"display":"flex","user-select":"none","position":"absolute","top":"0","left":"0","width":"100%"} }
const _hoisted_32 = { class: "stars_range_wrapper" }
const _hoisted_33 = { class: "w-100 text-start" }
const _hoisted_34 = {
  key: 0,
  style: {"margin-left":"4px"}
}
const _hoisted_35 = { class: "p-3" }
const _hoisted_36 = {
  class: "text-start pretty_button hover_ignore mt-0 d-flex flex-column justify-content-between align-items-start",
  style: {"position":"sticky","top":"0","max-width":"900px"}
}
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = { class: "fs-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = { class: "d-flex flex-wrap" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 0,
  class: "item vstack justify-content-between"
}
const _hoisted_45 = { class: "item_content row" }
const _hoisted_46 = { class: "item_thumbnail col-sm-12 col-md-4" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "col-sm-12 col-md-8" }
const _hoisted_49 = { class: "row justify-content-between w-100" }
const _hoisted_50 = { class: "col-7" }
const _hoisted_51 = { style: {"text-align":"start"} }
const _hoisted_52 = { class: "text-start" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "icon-location" }, null, -1)
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { class: "col-5" }
const _hoisted_56 = ["href"]
const _hoisted_57 = {
  key: 0,
  class: "text-start"
}
const _hoisted_58 = { class: "item_properties" }
const _hoisted_59 = { style: {"margin":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_HorizontalPanel = _resolveComponent("HorizontalPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hotels.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
              return _createElementVNode("div", {
                class: "col-12 loadingItem mb-3",
                style: {"height":"70px","border-radius":"7px"},
                key: i
              })
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
              return _createElementVNode("div", {
                class: "item loadingItem",
                key: index
              })
            }), 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass({'p-3':1,'sticky_filter':1,'showed':_ctx.filters_showed})
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: "d-flex align-items-center user-select-none",
                        style: {"cursor":"pointer"},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSort('min_price')))
                      }, [
                        _hoisted_13,
                        (_openBlock(), _createElementBlock("svg", {
                          style: _normalizeStyle({'fill': _ctx.sort_by === 'min_price' ? 'black' : '#8c979b','rotate': _ctx.sort_by === 'min_price' && !_ctx.sort_asc ? '' : '180deg'}),
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          width: "8",
                          height: "8",
                          x: "0px",
                          y: "0px",
                          viewBox: "0 0 1000 1000",
                          "enable-background": "new 0 0 1000 1000",
                          "xml:space": "preserve"
                        }, _hoisted_15, 4))
                      ]),
                      _createElementVNode("div", {
                        class: "d-flex align-items-center user-select-none",
                        style: {"cursor":"pointer"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSort('rating')))
                      }, [
                        _hoisted_16,
                        (_openBlock(), _createElementBlock("svg", {
                          style: _normalizeStyle({'fill': _ctx.sort_by === 'rating' ? 'black' : '#8c979b','rotate': _ctx.sort_by === 'rating' && !_ctx.sort_asc ? '' : '180deg'}),
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          width: "8",
                          height: "8",
                          x: "0px",
                          y: "0px",
                          viewBox: "0 0 1000 1000",
                          "enable-background": "new 0 0 1000 1000",
                          "xml:space": "preserve"
                        }, _hoisted_18, 4))
                      ])
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-12",
                    key: index
                  }, [
                    (filter.type === 'range')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("h5", _hoisted_21, _toDisplayString(filter.name), 1),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_Slider, {
                                "show-tooltip": "drag",
                                "tooltip-position": "bottom",
                                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyFilter())),
                                min: filter.min,
                                max: filter.max,
                                modelValue: filter.values,
                                "onUpdate:modelValue": ($event: any) => ((filter.values) = $event),
                                value: filter.values
                              }, null, 8, ["min", "max", "modelValue", "onUpdate:modelValue", "value"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", null, "от " + _toDisplayString(_ctx.getNumericValue(filter.values[0])) + " до " + _toDisplayString(_ctx.getNumericValue(filter.values[1])), 1),
                              (filter.symbol)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(filter.symbol), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : (filter.type === 'select')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_HorizontalPanel, null, {
                              title: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_26, _toDisplayString(filter.name), 1)
                              ]),
                              content: _withCtx(() => [
                                _createVNode(_component_SelectInput, {
                                  modelValue: filter.checked,
                                  "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event),
                                  value: filter.values,
                                  variants: filter.successes,
                                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.applyFilter()))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "variants"])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : (filter.type === 'stars_range')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("h5", _hoisted_29, _toDisplayString(filter.name), 1),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                                      return _createElementVNode("span", {
                                        class: _normalizeClass({star:1,col:1,active: i >= filter.values[0] && i <= filter.values[1]}),
                                        key: i
                                      }, " ★ ", 2)
                                    }), 64))
                                  ]),
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_Slider, {
                                      "show-tooltip": "drag",
                                      lazy: false,
                                      "tooltip-position": "bottom",
                                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.applyFilter())),
                                      min: 1,
                                      max: 5,
                                      modelValue: filter.values,
                                      "onUpdate:modelValue": ($event: any) => ((filter.values) = $event),
                                      value: filter.values
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("span", null, "от " + _toDisplayString(filter.values[0]) + " до " + _toDisplayString(filter.values[1]), 1),
                                  (filter.symbol)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(filter.symbol), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({'d-none': !_ctx.filters_showed}),
            style: {"z-index":"2","position":"fixed","top":"0","left":"0","width":"100%","height":"100%"},
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideFilters && _ctx.hideFilters(...args)))
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass({'col-sm-12':1,'col-md-9':1,'content':1,'blur': _ctx.filters_showed})
          }, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h5", null, [
                    _createElementVNode("span", _hoisted_38, "По запросу туров в " + _toDisplayString(_ctx.currentCountry.getDeclName()) + " на " + _toDisplayString(_ctx.search_data.adults_count) + " человек на " + _toDisplayString(_ctx.search_data.nights_count) + " ночей на " + _toDisplayString(_ctx.dateLocalization.localizeRu(_ctx.search_data.start_date)), 1),
                    _hoisted_39,
                    _createElementVNode("span", null, "Мы нашли " + _toDisplayString(_ctx.sortedTours.length) + " предложений", 1)
                  ]),
                  _createElementVNode("img", {
                    style: {"height":"20px"},
                    src: "https://travel.netwiz.ru//local/templates/travel/img/filter_new_icon.png",
                    class: "d-block d-sm-block d-md-none",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showFilters && _ctx.showFilters(...args)))
                  })
                ]),
                _createElementVNode("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilters, (filter, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "m-1",
                      key: index
                    }, [
                      (filter.type === 'select')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.checked, (value, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "pretty_block cursor-pointer",
                                onClick: ($event: any) => {filter.checked.splice(index,1);_ctx.applyFilter()}
                              }, _toDisplayString(filter.values[value]), 9, _hoisted_42))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "pretty_block cursor-pointer",
                            onClick: ($event: any) => (filter.reset())
                          }, _toDisplayString(filter.name) + " " + _toDisplayString(filter.to_string()) + " " + _toDisplayString(filter.symbol), 9, _hoisted_43))
                    ]))
                  }), 128))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.sortedTours, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (index < _ctx.paginate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("img", {
                              src: item.picture,
                              alt: ""
                            }, null, 8, _hoisted_47)
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("h4", _hoisted_51, _toDisplayString(item.name) + " " + _toDisplayString(item.stars) + "★ ", 1),
                                _createElementVNode("p", _hoisted_52, [
                                  _hoisted_53,
                                  _createTextVNode(" " + _toDisplayString(item.city || _ctx.currentCountry.getName()), 1)
                                ]),
                                _createElementVNode("p", {
                                  style: {"text-align":"justify"},
                                  innerHTML: item.description
                                }, null, 8, _hoisted_54)
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tours, (tour, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                                    _createElementVNode("a", {
                                      class: "text-start vstack",
                                      href: tour.link,
                                      target: "_blank"
                                    }, " от " + _toDisplayString(tour.min_price) + " ₽ на " + _toDisplayString(tour.marketplace), 9, _hoisted_56),
                                    (tour.rating)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_57, "Рейтинг: " + _toDisplayString(tour.rating) + "/5", 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.extras, (extra, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "item_property",
                              key: index
                            }, _toDisplayString(extra), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_59, [
                (_ctx.paginate < _ctx.sortedTours.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "pretty_button m-auto",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMore()))
                    }, " Загрузить еще "))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2)
        ]))
  ]))
}